export class Schedules {
    public added_by: number;
    public date_time_schedule: string;
    public status: number;
}
